import React, { useState } from "react";
import { createPortal } from "react-dom";
import "../component/modalAddProductUnit.css";

const ModalAddProductUnit = ({
  isShowModal,
  onCloseModal,
  onSubmitData,
  productUnitObject,
}) => {
  const [productUnitData, setProductUnitData] = useState(productUnitObject);

  const closeModal = () => {
    setProductUnitData({
      product_unit_id: "",
      product_unit_name: "",
    });
    onCloseModal();
  };

  return createPortal(
    isShowModal && (
      <div className="modal-product-unit-container">
        <div className="modal-product-unit-content">
          <header className="modal-product-unit-header">
            <h2 className="modal-product-unit-header-title">
              Tambah Unit Produk
            </h2>
            <button className="modal-header-close-button" onClick={closeModal}>
              &times;
            </button>
          </header>
          <main className="modal-product-unit-main">
            <div className="form-group">
              <div className="input_title_label_container">
                <span className="input_title_label">Unit Produk Baru</span>
              </div>
              <div className="input_product_unit_field_container">
                <input
                  type="text"
                  value={
                    productUnitData.product_unit_name
                      ? productUnitData.product_unit_name
                      : ""
                  }
                  onChange={(e) =>
                    setProductUnitData({
                      ...productUnitData,
                      product_unit_name: e.target.value,
                    })
                  }
                  placeholder="Masukkan unit produk"
                />
              </div>
            </div>
          </main>
          <footer className="modal-product-unit-footer">
            <button className="modal-close-button" onClick={closeModal}>
              Batal
            </button>
            <button
              className="modal-submit-button"
              onClick={() => {
                const isEditData = productUnitData.product_unit_id !== "";
                onSubmitData(productUnitData, isEditData);
                setProductUnitData({
                  product_unit_id: "",
                  product_unit_name: "",
                });
              }}
            >
              Submit
            </button>
          </footer>
        </div>
      </div>
    ),
    document.getElementById("modal")
  );
};

export default ModalAddProductUnit;
